module.exports = __webpack_public_path__ + "img/home_tk_s_icon.9e46437.png";